import { Component, OnInit } from '@angular/core';
import { PrizeForPrecisionService } from '../../services/prize-for-precision.service';
import { mergeMap, combineLatest, map, tap } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { BehaviorSubject, of } from 'rxjs';
import { Athlete, PriceForPrecisionAthlete } from '../../classes/prize-for-precision';
import { Input } from '@angular/core';
import { WaHelperService } from 'world-archery-lib';



@Component({
  selector: '[app-price-for-precision-item]',
  templateUrl: './price-for-precision-item.component.html',
  styleUrls: ['./price-for-precision-item.component.scss']
})
export class PriceForPrecisionItemComponent implements OnInit {
  @Input()
  athlete: PriceForPrecisionAthlete;
  showDetails = false;
  constructor(public filter_service: PrizeForPrecisionService, public http: HttpClient) {

  }

  ngOnInit() {

  }

  onClick() {
    this.showDetails = !this.showDetails;
  }
  getNameCountry(country: string) {

    return this.filter_service.country.find(value => value.NOC === country);
  }
}
